import React from "react";
import CardList from "@/modules/CardList";
import { $t } from './i18n';

class Card extends React.Component {
  render() {
    const { message = {}, id } = this.props
    return (
      <section id={id}>
        <h2 className="section-title">{$t(message.title)}</h2>
        <CardList list={message.list} />
      </section>
    );
  }
}

export default Card;
